<template>
  <tr>
    <td>
      {{ categoryTitle }} {{ statistics.isSelectedReference ? "(REF)" : "" }}
    </td>
    <td align="right">
      <template v-if="noDataFootnote">**</template>
      {{ common.formatNumber(statistics.sampleSize, 0) }}
    </td>
    <td align="right">
      {{ common.formatNumber(statistics.betaCoefficient, 2) }}
    </td>
    <td align="right">
      {{ common.formatNumber(statistics.standardError, 2) }}
    </td>
    <td align="right">{{ common.formatNumber(statistics.tStatistic, 2) }}</td>
    <td align="right">
      {{
        common.formatNumberWithMinimum(
          statistics.pValue,
          4,
          statistics.isPValueBelowMinimum
        )
      }}
    </td>
    <td align="right">{{ common.formatNumber(statistics.oddsRatio, 2) }}</td>
    <td align="right">{{ statistics.confidenceInterval }}</td>
  </tr>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from "@/scripts/common";

export default {
  props: [
    "variableRows",
    "isFirstRow",
    "categoryTitle",
    "statistics",
    "totalSourceRecords",
  ],
  data: function () {
    var vm = this;
    return {
      common: common,
      noDataFootnote: vm.totalSourceRecords === 0,
    };
  },
  methods: {},
};
</script>

<style scoped>
tr td:nth-child(1) {
  border: none;
  background-color: #c1d5b0;
}
</style>
